<template>
<transition name="modal">
  <div class="modal-mask" @click="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div>
          <CRow>
            <CCol>
              <table class="table">
                <thead>
                  <a style="font-size: 20px"><strong>削除内容確認</strong></a>
                  <CCardText><strong>以下の内容を削除してよろしいですか？</strong></CCardText>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <a><strong>部署名</strong></a><br>
                      {{ val.name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>部署コード</strong></a><br>
                      {{ val.code }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>親部署</strong></a><br>
                      {{ val.parent_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>部署長</strong></a><br>
                      {{ val.head_user_name }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a><strong>並び優先度</strong></a><br>
                      {{ val.order_level }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="10">
              <button @click="$emit('close')" class="btn btn-secondary btn-sm">キャンセル</button>
            </CCol>
            <CCol>
              <save-button
                :label="'削除'"
                :loading="loading"
                class="btn btn-danger"
                @click="$emit('delete')"
              />
            </CCol>
          </CRow>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import SaveButton from '../common/SaveButton'
export default {
  name: 'DepartmentDeleteModal',
  components: { SaveButton },
  props: {
    val: Object,
    loading: Boolean
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(80, 80, 80, 0.5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 40%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
